import i from './register.container';

export default i;
